import {
  client,
  getServiceHeaders,
  getServiceUrl,
  getAccessToken,
  ResponseCallback
} from '.'

/**
 *
 * @param path path to endpoint (e.g. /users/)
 * @param reqAuth boolean if request requires authentication
 * @param body Body of type I (can be any input)
 * @returns promise ServiceResponse <R>
 */
export const post = async <I, O>({
  path,
  query = {},
  body,
  token = getAccessToken(),
  headers,
  respCb,
  text,
  includeHeaders
}: {
  path: string
  query?: { [k: string]: string | number }
  body: I
  token?: string
  urlType?: 'IPA' | 'AUTH'
  headers?: HeadersInit
  respCb?: ResponseCallback<O>
  text?: boolean
  includeHeaders?: boolean
}): Promise<O> => {
  return client<I, O>({
    url: getServiceUrl(path, query),
    method: 'POST',
    headers: getServiceHeaders(token, headers),
    body,
    respCb,
    text,
    includeHeaders
  })
}
